<app-menu></app-menu>

<div class="search-page-container">
  <div class="mobile-filter-button">
    <button mat-stroked-button (click)="toggleFilters()"
      [matBadge]="activeFilterCount"
      [matBadgeHidden]="activeFilterCount === 0"
      matBadgeColor="accent"
      matBadgeSize="small">
      <mat-icon>filter_list</mat-icon>
      Filtros
    </button>
  </div>

  <aside class="filters-sidebar" [class.show]="showFilters">
    <div class="filters-header">
      <h2>Filtros</h2>
      <button mat-icon-button class="close-filters-btn" (click)="toggleFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="filter-group">
      <h3>Preço</h3>
      <mat-slider min="0" max="500" step="5" discrete="true">
        <input matSliderStartThumb [(ngModel)]="minPrice" (ngModelChange)="onFilterChange()">
        <input matSliderEndThumb [(ngModel)]="maxPrice" (ngModelChange)="onFilterChange()">
      </mat-slider>
      <div class="price-labels">
        <span>{{ minPrice | currency:'BRL' }}</span>
        <span>{{ maxPrice >= 500 ? 'Sem limite' : (maxPrice | currency:'BRL') }}</span>
      </div>
    </div>

    <div class="filter-group">
      <h3>Tipo</h3>
      <mat-checkbox [(ngModel)]="filterEbook" (change)="onFilterChange()">Ebook</mat-checkbox>
      <mat-checkbox [(ngModel)]="filterImpresso" (change)="onFilterChange()">Livro Impresso</mat-checkbox>
    </div>

    <div class="filter-group">
      <h3>ISBN</h3>
      <mat-form-field appearance="outline" class="filter-input">
        <mat-label>Buscar por ISBN</mat-label>
        <input matInput [(ngModel)]="filterIsbn" (ngModelChange)="onFilterChange()" placeholder="Ex: 978-85-...">
        <mat-icon matSuffix>menu_book</mat-icon>
      </mat-form-field>
    </div>

    <div class="filter-group">
      <h3>Autor</h3>
      <mat-form-field appearance="outline" class="filter-input">
        <mat-label>Buscar por autor</mat-label>
        <input matInput [(ngModel)]="filterAuthorName" (ngModelChange)="onFilterChange()" placeholder="Nome do autor">
        <mat-icon matSuffix>person</mat-icon>
      </mat-form-field>
    </div>

    <div class="filter-group">
      <h3>Categorias</h3>
      <mat-form-field appearance="outline" class="filter-input">
        <mat-label>Selecione categorias</mat-label>
        <mat-select [(ngModel)]="filterCategories" multiple (selectionChange)="onFilterChange()">
          @for (category of categories; track category.idCategory) {
            <mat-option [value]="category.idCategory">{{ category.categoryName }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>category</mat-icon>
      </mat-form-field>
    </div>
  </aside>

  <div class="filters-overlay" [class.show]="showFilters" (click)="toggleFilters()"></div>
  <main class="books-main-content">
    @if (isLoading && results.length === 0) {
    <div class="books-grid">
      <app-book [bookData]="null" [searchTerm]="searchTerm"></app-book>
      <app-book [bookData]="null" [searchTerm]="searchTerm"></app-book>
      <app-book [bookData]="null" [searchTerm]="searchTerm"></app-book>
      <app-book [bookData]="null" [searchTerm]="searchTerm"></app-book>
      <app-book [bookData]="null" [searchTerm]="searchTerm"></app-book>
      <app-book [bookData]="null" [searchTerm]="searchTerm"></app-book>


    </div>
    } @else {
    @if (results.length > 0) {
    <div class="books-grid">
      @for (book of results; track book.idKit) {
      <app-book [bookData]="book" [searchTerm]="searchTerm"></app-book>
      }
    </div>
    } @else {
    <app-empty-list title="Nenhum livro encontrado" subTitle="Tente ajustar seus filtros ou buscar por outros termos.">
    </app-empty-list>
    }

    @if (!allResultsLoaded && results.length > 0) {
    <div class="pagination-container">
      <button mat-raised-button class="btn-primary" (click)="loadMoreBooks()" [disabled]="isLoadingMore">
        @if (isLoadingMore) {
        <mat-spinner [diameter]="24" class="mat-spinner-btn"></mat-spinner>
        } @else {
        <span>Ver mais</span>
        }
      </button>
    </div>
    }
    }
  </main>
</div>

<app-footer></app-footer>